import React from 'react';
import PropTypes from 'prop-types';
import { stripTags } from '../../utils/helpers';
function Truncate(_ref) {
  var children = _ref.children,
    limit = _ref.limit;
  var truncatedStr = stripTags(children).slice(0, limit).trim();
  if (children.length > truncatedStr.length) {
    truncatedStr += '...';
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, truncatedStr);
}
Truncate.propTypes = {
  children: PropTypes.string.isRequired,
  limit: PropTypes.number.isRequired
};
export default Truncate;